import { FileResponse } from '../../components/interfaces/FileResponse';
import { MovementType } from '../../components/search/movement-button.component';

// The API only moves a sheet one step or to an end, so a drag becomes the shortest series of those moves
export const planMoves = (from: number, to: number, count: number): MovementType[] => {
    if (from === to) return [];
    if (to === 0) return [MovementType.First];
    if (to === count - 1) return [MovementType.Last];

    const direct = Array<MovementType>(Math.abs(to - from)).fill(to < from ? MovementType.Up : MovementType.Down);
    const viaFirst = [MovementType.First, ...Array<MovementType>(to).fill(MovementType.Down)];
    const viaLast = [MovementType.Last, ...Array<MovementType>(count - 1 - to).fill(MovementType.Up)];

    return [direct, viaFirst, viaLast].reduce((best, plan) => plan.length < best.length ? plan : best);
}

export const sameSheet = (a: FileResponse, b: FileResponse) => a.serverPath === b.serverPath && a.address === b.address;

// Mirrors the API's reordering so the list updates before the request returns
export const reorder = (items: FileResponse[], file: FileResponse, type: MovementType): FileResponse[] => {
    const from = items.findIndex(i => sameSheet(i, file));
    if (from < 0) return items;

    const next = [...items];
    const [moved] = next.splice(from, 1);

    if (type === MovementType.Remove) return next;

    const to = {
        [MovementType.First]: 0,
        [MovementType.Up]: Math.max(from - 1, 0),
        [MovementType.Down]: Math.min(from + 1, next.length),
        [MovementType.Last]: next.length,
    }[type];

    next.splice(to, 0, moved);
    return next;
}
